import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-export",
  "use": "icon-file-export-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file-export\">\n<path d=\"M1.63636 0C0.736364 0 0.00818201 0.81 0.00818201 1.8L0 16.2C0 17.19 0.728182 18 1.62818 18H11.4545C12.3545 18 13.0909 17.19 13.0909 16.2V5.4L8.18182 0H1.63636ZM7.36364 6.3V1.35L11.8636 6.3H7.36364Z\" fill=\"#53933A\" />\n<path d=\"M14.7355 9.45H4.90909V11.25H14.7355V13.95L18 10.35L14.7355 6.75V9.45Z\" fill=\"#53933A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol